const xpLevel = [  
    { level:0,    minXP:1,          maxXP:500},
    { level:1,    minXP:501,        maxXP:1500},
    { level:2,    minXP:1501,       maxXP:3000},
    { level:3,    minXP:3001,       maxXP:5000},
    { level:4,    minXP:5001,       maxXP:7500},
    { level:5,    minXP:7501,       maxXP:11000},
    { level:6,    minXP:11001,      maxXP:15000},
    { level:7,    minXP:15001,      maxXP:20000},
    { level:8,    minXP:20001,      maxXP:30000},
    { level:9,    minXP:30001,      maxXP:40000},
    { level:10,   minXP:40001,      maxXP:50000},
    { level:11,   minXP:50001,      maxXP:60000},
    { level:12,   minXP:60001,      maxXP:70000},
    { level:13,   minXP:70001,      maxXP:80000},
    { level:14,   minXP:80001,      maxXP:90000},
    { level:15,   minXP:90001,      maxXP:100000},
    { level:16,   minXP:100001,     maxXP:110000},
    { level:17,   minXP:110001,     maxXP:120000},
    { level:18,   minXP:120001,     maxXP:130000},
    { level:19,   minXP:130001,     maxXP:140000},
    { level:20,   minXP:140001,     maxXP:150000},
    { level:21,   minXP:150001,     maxXP:200000},
    { level:22,   minXP:200001,     maxXP:250000},
    { level:23,   minXP:250001,     maxXP:300000},
    { level:24,   minXP:300001,     maxXP:350000},
    { level:25,   minXP:350001,     maxXP:500000},
];

export default xpLevel;